import { BaseSelectRef } from 'rc-select';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { getDirectParent } from '@lib/popups';
import { Select } from 'antd';
import React, { forwardRef } from 'react';

export type AppActivityPeriodSelectOption = {
	label: string;
	value: number;
};

export interface AppActivityPeriodSelectProps {
	allowClear?: boolean;
	defaultValue?: number;
	getPopupContainer?: (trigger: HTMLElement) => HTMLElement;
	onChange?: (value: number, option: AppActivityPeriodSelectOption) => void;
}

const activityPeriodOptions = [ 1, 3, 7, 30, 90 ]
	.map((period) => ({
		label: COPY_GENERIC.DAYS(period),
		value: period
	}));

export const AppActivityPeriodSelect = forwardRef<BaseSelectRef, AppActivityPeriodSelectProps>(({
	allowClear,
	defaultValue,
	getPopupContainer,
	onChange,
	...rest
}, ref) =>
	<Select
		{ ...rest }
		allowClear={ allowClear }
		defaultValue={ defaultValue }
		getPopupContainer={ getPopupContainer ?? getDirectParent }
		onChange={ onChange }
		options={ activityPeriodOptions }
		ref={ ref }
		showAction={ [ 'focus', 'click' ] } />);
